import * as React from "react";
import { DomainDryRunConfig } from "./domainDryRunConfig";
import { useCpFormValue } from "../../gvc/testNewForm/utils";

interface Props {}
export const DnsConfig: React.FC<Props> = ({}) => {
  const config = useCpFormValue(`meta.dryRun.dns`);

  if (!config) {
    return null;
  }

  return (
    <div>
      <DomainDryRunConfig label={`DNS Config`} configs={config} />
    </div>
  );
};
